<template>
  <div>
    <History class="mb-3" :disable="true" :caption="$t('reportStatus')" :item="item" :pages="pages" :loading="loading" :fields="fields" :childrenFields="childrenFields"   />
    <ReportCompetency class="mb-3" :item="organizations" :loading="loading1"/>
    <History class="mb-3" :caption="$t('reportCompetency')" small :item="item1"  :loading="loading1" :is-hris="false"  />
<!--    <AssessmentSummary class="mb-3" :caption="$t('reportCompetency')" small :item="item1"  :loading="loading1" />-->

  </div>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";
import History from "@/projects/views/E-Performances/Dashboard/Admin/components/Historys";
import ReportCompetency from "@/projects/views/E-Performances/Dashboard/Admin/components/ReportCompetency";
import AssessmentSummary from "@/projects/views/E-Performances/Dashboard/Admin/components/AssessmentSummary";
import * as XLSX from "xlsx";

export default {
  name: "index",
  components: {AssessmentSummary, ReportCompetency, History},
  data: function () {
    return {
      pages : {
        values:[100,200,500,1000,2000]
      },
      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: "00000000000000000000000",
        year: new Date().getFullYear() + 543,
      },

      defaultDatasets:[],


      //
      loading : true,
      item:[],
      fields :[
        {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
        {key:"title", label:"Title", },
        {key:"total", label: "Total", _style: 'width:150px; text-align: center'},
        {key:"completed", label: "Completed", _style: 'width:150px; text-align: center'},
        {key:"doing", label: "Doing", _style: 'width:150px; text-align: center'},
        {key:"pending", label: "Pending", _style: 'width:150px; text-align: center'},
        //
        {key:"action", label: "#", _style: 'width:30px; text-align: center'}
      ],
      childrenFields :[
        {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
        {key:"info", label:"Name"},

        {key:"competencyLevel", label:"level"},

        {key:"assessor1", label:"Assessor 1"},
        {key:"assessor2", label:"Assessor 2"},
        {key:"status", label:"Status"},

        // {key:"dateTime", label:"Start Date"},
        // {key:"experiences", label:"Experience", _style: 'width:220px; text-align: center'},
        {key:"action", label: "#", _style: 'width:30px; text-align: center'}
      ],

      organizations:[],

      loading1 : true,
      item1:[],

      array : []
    }

  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },

    onLoad(){

      if(this.$store.getters["personal/profile"].role != 0){
        var body = {};
        body.group = true;
        if(this.$store.getters["personal/profile"].role != 1){
          body.agency = this.$store.getters["personal/profile"].agency._id
        }
        this.$store.dispatch("estimate/reportsStatus",body)
        this.$store.dispatch("estimate/reportsGroups",body)
      }

    },


  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
      userId:"auth/userId",

      reportsStatus: 'estimate/reportsStatus',
      reportsGroup: 'estimate/reportsGroup',

      isReload: 'assessment/isReload'
    }),
  },

  watch: {
    lang(value){
      this.onLoad();
    },
    reportsStatus(value){
      this.array = []
      this.loading = false;
      var count = 0

      var objsArray = [];

      value.filter(item => {

        var objs = {};
        objs.code = item.code;
        objs.title = item.title.filter(value => {
          if (value.key == this.lang) {
            return value
          }
        })[0].value;
        // objs.title = item.title;
        count = count+item.completed;
        objs.completed = item.completed;
        objs.total = item.item.length;
        objs.item = item.item;

        objs.doing = item.doing;
        objs.pending = item.pending;
        if(value.length === 1){
          objs._toggled = true;
        }
        objsArray.push(objs)
      })
      this.item = objsArray;

      // console.log(1122,objsArray);

      var items = []
      // console.log(this.item)
      for(var i=0; i<this.item.length; i++){
        for(var j=0; j<this.item[i].item.length; j++){
          var objs = this.item[i].item[j];
          var objsD = {};
          objsD['หน่วยงาน'] = this.item[i].title;
          objsD['รหัสพนักงาน'] = objs.code;
          objsD['ชื่อ - นามสกุลพนักงาน'] = objs.info;
          objsD['ปีการประเมิน (ปี พ.ศ.)'] = objs.year;
          // objsD['รหัสข้อมูลรายการสมรรถนะ'] = objs.cc.split("-")[0];
          // objsD['ชื่อรายการสมรรถนะ'] = objs.cc.split("-")[1];
          // objsD['ระดับที่คาดหวัง'] = objs.competencyLevel;
          // objsD['ประเมินตนเอง'] = objs.assessment0;
          objsD['ผู้ประเมิน 1'] = objs.assessor1;
          objsD['ผู้ประเมิน 2'] = objs.assessor2;
          // objsD['สรุปผล'] = objs.gapSum;
          objsD['สถานะ'] = objs.status;
          //
          items.push(objsD)

        }
      }

      const worksheet = XLSX.utils.json_to_sheet(items);
      worksheet['!cols'] = [
        { wpx: 170 }, { wpx: 80 }, { wpx: 170 }, { wpx: 115 }, { wpx: 136 },
        { wpx: 170 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 },
      ];

// สร้าง workbook และเพิ่ม worksheet แรก
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "All");

// บันทึกไฟล์
//       XLSX.writeFile(workbook, "Status.xlsx");
      // }
    },


    download(name) {

      var items = []
      // console.log(this.item)
      for(var i=0; i<this.item.length; i++){
        for(var j=0; j<this.item[i].item.length; j++){
          var objs = this.item[i].item[j];
          var objsD = {};
          objsD['หน่วยงาน'] = this.item[i].title;
          objsD['รหัสพนักงาน'] = objs.code;
          objsD['ชื่อ - นามสกุลพนักงาน'] = objs.info;
          objsD['ปีการประเมิน (ปี พ.ศ.)'] = objs.year;
          // objsD['รหัสข้อมูลรายการสมรรถนะ'] = objs.cc.split("-")[0];
          // objsD['ชื่อรายการสมรรถนะ'] = objs.cc.split("-")[1];
          // objsD['ระดับที่คาดหวัง'] = objs.competencyLevel;
          // objsD['ประเมินตนเอง'] = objs.assessment0;
          objsD['ผู้ประเมิน 1'] = objs.assessment1;
          objsD['ผู้ประเมิน 2'] = objs.assessment2;
          // objsD['สรุปผล'] = objs.gapSum;
          objsD['สถานะ'] = objs.status;
          //
          items.push(objsD)

        }
      }

//       const worksheet = XLSX.utils.json_to_sheet(items);
//       worksheet['!cols'] = [
//         { wpx: 170 }, { wpx: 80 }, { wpx: 170 }, { wpx: 115 }, { wpx: 136 },
//         { wpx: 170 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 },
//       ];
//
// // สร้าง workbook และเพิ่ม worksheet แรก
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "All");
//
// // บันทึกไฟล์
//       XLSX.writeFile(workbook, "Status.xlsx");


      // var result = item.item.map(objs => ({
      // 'รหัสพนักงาน': objs.code,
      // 'ชื่อ - นามสกุลพนักงาน': objs.info,
      // 'ปีการประเมิน (ปี พ.ศ.)': objs.year,
      // 'รหัสข้อมูลรายการสมรรถนะ': objs.cc.split("-")[0],
      // 'ชื่อรายการสมรรถนะ': objs.cc.split("-")[1],
      // 'ระดับที่คาดหวัง': objs.competencyLevel,
      // 'ประเมินตนเอง': objs.assessment0,
      // 'ผู้ประเมิน 1': objs.assessment1,
      // 'ผู้ประเมิน 2': objs.assessment2,
      // 'สรุปผล': objs.gapSum
      // }));


    },


    reportsGroup(value){

      //
      // value = value.filter(item => {
      //   return this.array.includes(item.code);
      // });

      this.loading1 = false;

      const mergedData = {};
      value.forEach(item => {
        item.explorerAgency.forEach(entry => {
          if (!mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value]) {
            mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value] = { title: entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value, complete: 0, total: 0, isGap: 0, isMeets: 0, isExceeding: 0 };
          }

          mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value].total += item.member;
          mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value].complete += entry.total;
          mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value].isGap += entry.isGap;


          mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value].isMeets += entry.isMeets;
          mergedData[entry.title.filter(title => { if (title.key == this.lang) { return title } })[0].value].isExceeding += entry.isExceeding;

        });
      });

      this.organizations =  Object.values(mergedData);


      value.filter(item => {
        item.title = item.title.filter(title => {
          if (title.key == this.lang) {
            return title
          }
        })[0].value;
        item.total = item.item.length;
        item.explorerAgency.filter(objs => {
          objs.title = objs.title.filter(title => {
            if (title.key == this.lang) {
              return title
            }
          })[0].value;
        })
        if(value.length === 1){
          item._toggled = true;
        }
      })
      this.item1 = value


    },

    isReload(value){
      if (value == true) {
        this.onLoad()
        this.$store.commit("assessment/isReload", false)
      }
    }
  }

}
</script>

<style scoped>

</style>
